import {TimelineMetadata} from '@app/timeline/timeline-types';

export function resolveDefaultTimelineYear(metadata: TimelineMetadata): number {
  const hasCurrentYearContent = metadata.years.some(
    entry =>
      entry.year === metadata.current_year && entry.titles_count > 0,
  );

  if (hasCurrentYearContent) {
    return metadata.current_year;
  }

  return metadata.years.at(-1)?.year ?? metadata.current_year;
}
